import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let appInsightsInstance: ApplicationInsights | null = null;

export function useAppInsights() {
  if (!appInsightsInstance) {
    appInsightsInstance = new ApplicationInsights({
      config: {
        connectionString: process.env.VUE_APP_APP_INSIGHTS,
        appId: process.env.VUE_APP_JSS_APP_NAME,
        excludeRequestFromAutoTrackingPatterns: [/\*.svg/g, /\*.js/g, /\*.css/g],
        enableAutoRouteTracking: true,
        enableAjaxPerfTracking: true,
        enableUnhandledPromiseRejectionTracking: true,
        enableAjaxErrorStatusText: true,
        disableFetchTracking: true,
        addRequestContext: (context) => ({
          JsonResponseBody: context?.xhr?.response,
        }),
      },
    });
    appInsightsInstance.loadAppInsights();
  }

  return appInsightsInstance;
}
